import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import FormProvider from "../../../../components/hook-form/form-provider";
import { RHFTextField } from "../../../../components/hook-form";
import { LoadingButton } from "@mui/lab";
import { UseFormReturn } from "react-hook-form";

type Props = {
    open: boolean;
    onClose: VoidFunction;
    methods: UseFormReturn<{        
        name: string;
        link: string;
    }, any, undefined>,
    onSubmit: VoidFunction;
    isSubmitting: boolean;
}

const CreateSystemDialogComponent = ({ open, onClose, methods, onSubmit, isSubmitting }: Props) => {

    return (
        <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
            <DialogTitle sx={{ p: (theme) => theme.spacing(3, 3, 2, 3) }}>Cadastrar Sistema</DialogTitle>
            <FormProvider methods={methods} onSubmit={onSubmit}>
                <DialogContent dividers sx={{ pt: 1, pb: 0, border: 'none' }}>
                    <RHFTextField
                        label="Nome do Sistema"
                        name="name"
                        fullWidth
                        sx={{ mb: 3 }}
                    />
                    <RHFTextField
                        label="Link do Sistema"
                        name="link"
                        fullWidth
                        sx={{ mb: 3 }}
                    />
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        variant="contained"
                        type="submit"
                        loading={isSubmitting}
                    >
                        Cadastrar Sistema
                    </LoadingButton>
                </DialogActions>
            </FormProvider>
        </Dialog>
    );

}

export default CreateSystemDialogComponent;